import { STAR_BANK_NAMESPACE_ID } from "src/constants"
import { DEPOSIT_ACCOUNTS, CONSUMER_ACCOUNT } from "src/features/LoansHome/Products/constants"
import {
    STATUS_APPLICATION_STARTED, STATUS_SUBMITTED,
    STATUS_WITHDRAW, STATUS_DECLINED, STATUS_DENIAL_UNDER_REVIEW,
    STATUS_UNDER_REVIEW, STATUS_RECOMMENDED_DECLINE, STATUS_APPROVED,
    STATUS_DOCUMENTS_SIGNED, SMARTMATCH_TYPE_ADMIN,
    SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_LOAN_PROCESSOR,
    SMARTMATCH_TYPE_LOAN_ASSISTANT, STATUS_APPROVED_NOT_ACCEPTED,
    STATUS_CLOSED_FOR_INCOMPLETENESS, STATUS_PRE_QUALIFIED,
    STATUS_RECOMMENDED_APPROVE, STATUS_BOOKING_COMPLETE
} from "src/services/constants"

const stageSubmitted = {
    name: STATUS_SUBMITTED,
    display_name: STATUS_SUBMITTED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 3
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}


const stageStartedDeposit = {
    name: STATUS_APPLICATION_STARTED,
    display_name: STATUS_APPLICATION_STARTED,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                }
            ]
        },
    ]
}


const stageUnderReviewDeposit = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
            ]
        },
    ]
}

const stageApprovedDeposit = {
    name: STATUS_APPROVED,
    display_name: STATUS_APPROVED,
    order_id: 3,
    children: [
        {
            stages: [
                {
                    name: STATUS_DOCUMENTS_SIGNED,
                    display_name: STATUS_DOCUMENTS_SIGNED
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
            ]
        },
    ]
}

const stageDocSignDeposit = {
    name: STATUS_DOCUMENTS_SIGNED,
    display_name: STATUS_DOCUMENTS_SIGNED,
    order_id: 3,
    children: [
        {
            stages: [
                {
                    name: STATUS_BOOKING_COMPLETE,
                    display_name: STATUS_BOOKING_COMPLETE
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
            ]
        },
    ]
}

const stageClosedDeposit = {
    name: STATUS_BOOKING_COMPLETE,
    display_name: STATUS_BOOKING_COMPLETE,
    order_id: 4,
    children: [
        {
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
            ]
        },
    ]
}

const stageDeclinedDeposit = {
    name: STATUS_DECLINED,
    display_name: STATUS_DECLINED,
    order_id: 5,
    children: [
        {
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        }
    ]
}

const stageWithdrawnDeposit = {
    name: STATUS_WITHDRAW,
    display_name: STATUS_WITHDRAW,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        }
    ]
}





export const loStageDepositConfigs = {
    id: '154878745215745755',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [DEPOSIT_ACCOUNTS],
    sub_loan_types: [CONSUMER_ACCOUNT],
    roles: [
        SMARTMATCH_TYPE_ADMIN,
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_LOAN_PROCESSOR,
        SMARTMATCH_TYPE_LOAN_ASSISTANT
    ],
    stages: [
        stageStartedDeposit,
        stageSubmitted,
        stageUnderReviewDeposit,
        stageApprovedDeposit,
        stageDocSignDeposit,
        stageClosedDeposit,
        stageDeclinedDeposit,
        stageWithdrawnDeposit
    ]
} as any;

